export default "__VITE_ASSET__BP389q3q__"